import React, { useEffect, useState } from "react";
import { Box, FormControl, Select, MenuItem, Grid } from "@material-ui/core";
import smartParkService from "../../axios";
import ClipLoader from "react-spinners/ClipLoader";
import HighchartsReact from "highcharts-react-official";
import HighStock from "highcharts/highstock";

const MafcEquipmentPopularTimes = ({ options, startDate, endDate }) => {
  const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const [loading, setLoading] = useState(false);
  const [selectedDay, setSelectedDay] = useState(new Date().getDay());
  const [selectedEquipment, setSelectedEquipment] = useState("");
  const [graphData, setGraphData] = useState([]);

  const getConfig = () => ({
    // plotOptions: {
    //   height: 100,
    // },
    title: {
      text: "",
      align: "left",
    },
    chart: {
      type: "column",
    },
    xAxis: {
      categories: [
        "6 am",
        "7 am",
        "8 am",
        "9 am",
        "10 am",
        "11 am",
        "12",
        "1 pm",
        "2 pm",
        "3 pm",
        "4 pm",
        "5 pm",
        "6 pm",
        "7 pm",
        "8 pm",
        "9 pm",
        "10 pm",
      ],
    },
    yAxis: {
      visible: false,
      min: 0,
      title: {
        text: "",
      },
    },
    tooltip: {
      split: true,
      formatter: function () {
        var crowd = this.y;
        if (crowd >= 10)
          return "Occupied " + crowd + " times.</br> Usually Busy On " + this.x;
        else
          return (
            "Occupied " +
            crowd +
            " times.</br> Usually Not So Busy On " +
            this.x
          );
      },
    },
    series: [
      {
        showInLegend: false,
        data: graphData,
        color: "#0076bb",
      },
    ],
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 600,
          },
          chartOptions: {
            xAxis: {
              labels: {
                rotation: -45,
                align: "center",
              },
            },
          },
        },
      ],
    },
    credits: {
      enabled: false,
    },
  });

  const fetchData = () => {
    setLoading(true);

    smartParkService
      .get(
        `api/equipment/populartimes?startDate=${startDate}&endDate=${endDate}&facility=91474e36-76c5-4d59-a8da-2998ab14a4bf&sensor=${selectedEquipment}&weekday=${selectedDay}`
      )
      .then((res) => {
        setGraphData(res.data.resultArray);
      })
      .catch((err) => {
        console.log("error", err);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    if (options && options.length > 0) {
      setSelectedEquipment(options[0].value);
    }
  }, [options]);

  useEffect(() => {
    if (!startDate || !endDate) return;
    if (selectedEquipment !== "" && selectedDay !== null) {
      fetchData();
    }
  }, [selectedEquipment, selectedDay, startDate, endDate]);

  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        height: "100%",
        width: "100%",
        padding: "5px",
        justifyContent: "space-between",
      }}
    >
      <Box
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          flex: 1,
        }}
      >
        <Box>
          {options && selectedEquipment !== "" && (
            <FormControl variant="outlined" fullWidth>
              <Select
                labelId="equipment-select-label"
                id="equipment-select"
                value={selectedEquipment}
                onChange={(e) => setSelectedEquipment(e.target.value)}
                label="Equipment"
                fullWidth
              >
                {options.map((option) => {
                  return (
                    <MenuItem value={option.value} key={option.value}>
                      {option.name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          )}
        </Box>
        <Box
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-evenly",
          }}
        >
          {daysOfWeek.map((day, index) => {
            return (
              <Box
                key={day}
                style={{
                  cursor: "pointer",
                  borderBottom:
                    selectedDay === index ? "2px solid #000" : "none",
                }}
                onClick={() => setSelectedDay(index)}
              >
                {day}
              </Box>
            );
          })}
        </Box>
      </Box>
      <Box
        style={{
          flex: 5,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {loading ? (
          <ClipLoader
            loading={loading}
            size={60}
            css={{
              display: "block",
              borderColor: "#0076bb",
            }}
          />
        ) : (
          <Box
            style={{
              width: "100%",
              padding: "5px",
              overflow: "hidden",
            }}
          >
            <HighchartsReact
              highcharts={HighStock}
              options={getConfig(graphData)}
              containerProps={{ style: { height: "100%", width: "100%" } }}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default MafcEquipmentPopularTimes;
